import * as React from 'react';
import {Link} from 'react-router-dom';

import {LeadTwoLine} from 'shells/lead/lead-two-line';
import {LeadFormattedValue} from 'shells/lead-card/lead-formatted-value';
import {LinkedEntity} from 'shells/linked-entity/linked-entity';
import {Body} from 'shells/typography/body';

import type {LeadSearchResultByType as LeadSearchResultFragment} from 'nutshell-graphql-types';

import styles from './search-results.module.css';

type Props = LeadSearchResultFragment & {
    isActive?: boolean;
};

export const secondaryInfo = (
    assignee?: {
        name: string;
    } | null,
    formattedValue?: any | null
): React.ReactNode | null | undefined => {
    return (
        <div className='flex justify-sb'>
            <div>
                {assignee && (
                    <LinkedEntity name={assignee.name} type='users' useEntityColor={true} />
                )}
            </div>
            {formattedValue && (
                <Body color='dark' isBold={true}>
                    <LeadFormattedValue
                        formattedValue={{
                            formatted: formattedValue.formatted,
                            prefix: formattedValue.prefix,
                            suffix: formattedValue.suffix,
                            value: formattedValue.value,
                        }}
                    />
                </Body>
            )}
        </div>
    );
};

export const SearchResultLead = (props: Props) => {
    const primaryAccount = props.accounts.primaryEdge && props.accounts.primaryEdge.node;
    const primaryContact = props.contacts.primaryEdge && props.contacts.primaryEdge.node;

    return (
        // @ts-expect-error
        <Link
            to={props.htmlUrlPath}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation()}
            className={
                props.isActive ? styles['search-result--fake-focus'] : styles['search-result']
            }
        >
            <LeadTwoLine
                isLinkable={false}
                disableRouting={true}
                leadName={props.name}
                leadNumber={props.number}
                leadStatus={props.status}
                htmlUrl={props.htmlUrlPath}
                priority={props.priority}
                avatarUrl={props.avatarUrl}
                relatedPerson={primaryContact}
                relatedCompany={primaryAccount}
                isSmall={true}
            />
            <div className={styles['secondary-info']}>
                {secondaryInfo(props.assignee, props.value && props.value.formattedValue)}
            </div>
        </Link>
    );
};
